"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var HeaderIcon = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(HeaderIcon, _React$Component);

  var _super = _createSuper(HeaderIcon);

  function HeaderIcon() {
    (0, _classCallCheck2["default"])(this, HeaderIcon);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(HeaderIcon, [{
    key: "findLinkSource",
    value: function findLinkSource(link) {
      if (link) {
        if (link.includes('google')) return {
          name: 'google plus',
          style: {
            color: '#DD4B39'
          }
        };
        if (link.includes('facebook')) return {
          name: 'facebook',
          style: {
            color: '#3b5998'
          }
        };
        if (link.includes('yelp')) return {
          name: 'yelp',
          style: {
            color: '#c41200'
          }
        };
        if (link.includes('tripadvisor')) return {
          name: 'tripadvisor',
          style: {
            color: '#00af87'
          }
        };
      }

      return {
        name: '',
        style: {}
      };
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(iconProps) {
      var name = iconProps.name,
          style = iconProps.style;
      return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", null, " "), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
        name: name,
        style: style,
        size: "small"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          link = _this$props.link,
          showLink = _this$props.showLink,
          isVerticalItem = _this$props.isVerticalItem;
      var iconProps = this.findLinkSource(link); // For verticalItems we need to override the default <Header.Content /> CSS in ItemElement

      if (isVerticalItem) iconProps.style = _objectSpread(_objectSpread({}, iconProps.style), {}, {
        display: 'inline-block',
        fontSize: '1em'
      });
      var icon = this.renderIcon(iconProps);
      return link && showLink ? /*#__PURE__*/_react["default"].createElement("a", {
        href: link,
        target: "_blank"
      }, icon) : icon;
    }
  }]);
  return HeaderIcon;
}(_react["default"].Component);

exports["default"] = HeaderIcon;
HeaderIcon.propTypes = {
  link: _propTypes["default"].string.isRequired,
  showLink: _propTypes["default"].bool,
  isVerticalItem: _propTypes["default"].bool
};
HeaderIcon.defaultProps = {
  showLink: true,
  isVerticalItem: false
};